import { gql } from 'graphql-tag'

const staffingPlanFragment = gql`
  fragment StaffingPlanFragment on StaffingPlan {
    totalIncentivesTarget
    totalThumbablesTarget
    roster {
      user {
        id
        name
      }
      startTime
      endTime
      startDateTime
      endDateTime
      position
      responsibility
      salesIncentiveTarget
      thumbsUpTarget
      salesIncentiveActual
      thumbsUpActual
      note
      breaks
    }
  }
`

export const getStaffingPlan = gql`
  query GetStaffingPlan($stationId: ID!, $date: String!, $mode: StaffPlanMode!) {
    staffPlan(stationId: $stationId, date: $date, mode: $mode) {
      id
      date
      ...StaffingPlanFragment
    }
    availableShiftResponsibilities(stationId: $stationId) {
      id
      name
    }
    stationActivityDescriptions(stationId: $stationId) {
      id
      name
      description
    }
  }
  ${staffingPlanFragment}
`
export const createStaffingPlan = gql`
  mutation CreateStaffingPlan($stationId: ID!, $data: CreateStaffingPlanInputType!) {
    createStaffingPlan(stationId: $stationId, data: $data) {
      id
      date
      ...StaffingPlanFragment
    }
  }
  ${staffingPlanFragment}
`

export const importStaffingPlan = gql`
  mutation ImportStaffingPlan($stationId: ID!, $date: String!) {
    importStaffingPlan(stationId: $stationId, date: $date) {
      id
      date
      ...StaffingPlanFragment
    }
  }
  ${staffingPlanFragment}
`
